import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BadgeCheckIcon, XIcon } from 'lucide-react';
import { recentPurchases } from '../data/recentPurchases';
const PACK_THUMB = 'https://cdn.magicpatterns.com/uploads/h1uENcARueCWxKfvcsbvYY/4a9ea000-d4dd-4c3b-b564-785200475fef.webp';
const FIRST_DELAY = 5000;
const VISIBLE_MS = 6500;
const GAP_MS = 10000;
const EASE = [0.23, 1, 0.32, 1] as const;
export function PurchaseToast() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer = 0;
    const showTimer = window.setTimeout(() => {
      setVisible(true);
      hideTimer = window.setTimeout(() => {
        setVisible(false);
        setIndex(prev => (prev + 1) % recentPurchases.length);
      }, VISIBLE_MS);
    }, index === 0 ? FIRST_DELAY : GAP_MS);
    return () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(hideTimer);
    };
  }, [index, dismissed]);
  const purchase = recentPurchases[index];
  return <div aria-live="polite" className="pointer-events-none fixed bottom-4 left-4 z-40 w-[19.5rem] max-w-[calc(100vw-2rem)] sm:bottom-6 sm:left-6 sm:w-[21rem]" data-id="element-184" data-mp="1z7oyatzfi9a9">
      <AnimatePresence data-id="element-185" data-mp="285qvszjyejss">
        {visible && !dismissed && <motion.div key={`${purchase.name}-${index}`} initial={{
        opacity: 0,
        x: -28,
        scale: 0.97
      }} animate={{
        opacity: 1,
        x: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        x: -20,
        scale: 0.98
      }} transition={{
        duration: 0.28,
        ease: EASE
      }} className="pointer-events-auto relative overflow-hidden rounded-2xl bg-inverse pl-1.5 shadow-float ring-2 ring-primary" data-id="element-186" data-mp="1bgjhabhr5ayd">
            <span aria-hidden="true" className="absolute inset-y-0 left-0 w-1.5 bg-primary" data-id="element-187" data-mp="rrhh6x5ik9f5" />

            <div className="flex items-center gap-3 py-3 pl-3 pr-9" data-id="element-188" data-mp="20217nbapu1mc">
              <img src={PACK_THUMB} alt="" className="h-14 w-14 shrink-0 rounded-lg bg-surface object-contain p-1" data-id="element-189" data-mp="2006mbvvj87hq" />

              <div className="min-w-0" data-id="element-190" data-mp="28t1im030usvd">
                <span className="inline-flex items-center gap-1 rounded-full bg-primary px-2 py-0.5 text-[9px] font-extrabold uppercase tracking-[0.12em] text-surface" data-id="element-191" data-mp="28w5s9cz9agtf">
                  <span className="relative flex h-1.5 w-1.5" data-id="element-192" data-mp="1h3ovdgoicbmj">
                    <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-surface opacity-75 motion-reduce:animate-none" data-id="element-193" data-mp="1c4u4drgdzgrc" />
                    <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-surface" data-id="element-194" data-mp="1q1qshl54ek4j" />
                  </span>
                  Acquisto ora
                </span>

                <p className="mt-1.5 truncate text-[13px] font-bold leading-tight text-surface" data-id="element-195" data-mp="31hpbagq3okiy">
                  {purchase.name} da {purchase.city}
                </p>
                <p className="mt-0.5 flex items-center gap-1 truncate text-[11px] text-surface/65" data-id="element-196" data-mp="350eiut338rfj">
                  <BadgeCheckIcon className="h-3.5 w-3.5 shrink-0 text-highlight" aria-hidden="true" data-id="element-197" data-mp="392rqxo5b51fh" />
                  Ha preso il pack ·{' '}
                  <span className="font-semibold text-highlight" data-id="element-198" data-mp="3011pdphpom3z">
                    {purchase.minutesAgo} min fa
                  </span>
                </p>
              </div>
            </div>

            <button type="button" onClick={() => setDismissed(true)} aria-label="Chiudi la notifica" className="absolute right-1.5 top-1.5 inline-flex h-6 w-6 items-center justify-center rounded-full text-surface/50 transition-colors duration-150 hover:bg-surface/10 hover:text-surface focus:outline-none focus-visible:ring-2 focus-visible:ring-primary" data-id="element-199" data-mp="3sqs33xffllzk">
              <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-200" data-mp="fcduy7jwyz5o" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}